import React from 'react';
import { TaskCompletionChart } from '../charts/TaskCompletionChart';
import { TeamPerformanceChart } from '../charts/TeamPerformanceChart';
import { AnalyticsSummary } from './AnalyticsSummary';

export const ChartSection = () => {
  return (
    <div className="space-y-6">
      <AnalyticsSummary />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
            Task Completion Trend
          </h2>
          <TaskCompletionChart />
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
            Team Performance
          </h2>
          <TeamPerformanceChart />
        </div>
      </div>
    </div>
  );
};